<template>
  <div class="details">
    <titleBar :title="title"></titleBar>
    <div class="details_content">
      <div class="details_bgimg" v-if="data.imageList" @click="closeModal">
        <img v-for="(item , index) in data.imageList" :src="item.url" />
      </div>
      <p class="details_bottom_tips" v-if="orderId">已存在待支付订单，请直接支付</p>
      <p class="details_bottom_tips" v-if="mix_price && isShow">暂不支持0元课和有价课同时购买，请您见谅</p>
      <div class="details_bottom">
        <template v-if="btn_status">
          <div class="details_bottom_left">
            <div class="details_money">
              <span v-if="price == '免费'" class="details_money_nofree">免费</span>
              <span v-else class="details_money_nofree">
                ¥{{price / 100}}
                <span class="details_money_nofree_span">起</span>
              </span>
            </div>
            <span class="details_people">{{data.totalEnrollment}}人已报名</span>
          </div>
          <div class="details_bottom_right" @click="showModal">
            <span v-if="orderId" @click="pay_click">去支付</span>
            <template v-else>
              <span v-if="data.orderState == 0" @click="pay_event">立即报名</span>
              <span v-if="data.orderState == 2" @click="show_method">已购买</span>
            </template>
          </div>
        </template>
        <p v-else @click="pay_click">立即购买</p>
      </div>
      <div class="details_modal" ref="modal" @click.stop>
        <div class="details_modal_title">
          <div class="details_modal_title_top">选择课程</div>
          <div class="details_modal_title_middle">
            <span>一年级</span>
            <span>{{data.activityName}}</span>
          </div>
        </div>
        <div
          class="details_modal_item"
          :style="{'padding-bottom':(mix_price ? '1.1rem' : '.2rem')}"
        >
          <div class="details_modal_item_main" v-for=" el,$index in data.classList" ref="list_item">
            <template v-if="el.subject == 0 || el.subject == 1 || el.subject == 2">
              <img class="details_modal_item_main_header" :src="el.teacherHeadPhoto" />
              <div class="details_modal_item_main_detail">
                <div class="details_modal_item_main_detail_time">
                  <template
                    v-if="el.weekdays && el.weekdays.split('、').length == 7"
                  >{{el.startDate}}-{{el.endDate}} 每天 {{el.lessonStart}} 开课</template>
                  <template
                    v-else-if="el.weekdays && el.weekdays.split('、').length > 3 && el.weekdays"
                  >{{el.startDate}}-{{el.endDate}} 每周上课时间：{{el.lessonStart}}</template>
                  <template
                    v-else-if="el.weekdays && el.weekdays.split('、').length <= 3 && el.weekdays"
                  >{{el.startDate}}-{{el.endDate}} 每周 {{el.weekdays}} {{el.lessonStart}} 开课</template>
                </div>
                <div class="details_modal_item_main_detail_other">
                  <span v-if="el.subject == 0">数学</span>
                  <span v-else-if="el.subject == 1">语文</span>
                  <span v-else-if="el.subject == 2">英语</span>
                  <span>{{el.teacherName}}</span>
                  <span v-if="el.orderState == 2" class="details_modal_item_main_detail_other_1">已购买</span>
                  <span
                    v-if="el.begun == 1"
                    :class="[el.orderState == 2 ? 'details_modal_item_main_detail_other_1' : 'details_modal_item_main_detail_other_2']"
                  >已开课</span>
                </div>
              </div>
              <input
                v-if="el.orderState == 2"
                class="radio_input"
                type="checkbox"
                disabled="disabled"
              />
              <input
                v-else
                class="radio_input"
                type="checkbox"
                :value="el.productId"
                v-model="product_arr"
                @click="input_event($index)"
              />
              <label :for="el.productId" :class="{no_check : el.orderState == 2}"></label>
              <span
                class="details_modal_item_main_radio"
                :class="{no_check : el.orderState == 2}"
              >¥{{el.salePrice / 100}}</span>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tips" class="mark" @click="close_tips" @touchmove.prevent>
      <div class="tips_bottom" @click.stop>
        <div v-if="tips == 'method'" class="method">
          <h2>上课方式</h2>
          <p>
            1.电脑：浏览器打开官网
            <span @click="copy_event">复制网址</span>
          </p>
          <p>2.手机/pad：应用市场内下载小象辅导APP</p>
          <p>
            3.如有疑问可咨询人工客服
            <span>
              <a @click="call_event">拨打电话</a>
            </span>
          </p>
          <p>记得使用家长盒子的注册手机号登录哦～</p>
        </div>
      </div>
    </div>
    <p v-if="toast" class="toast">{{toast}}</p>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/titleBar.vue";
import lesson_loading from "@/components/common/lesson_loading.vue";
import BSroll from "better-scroll";
let vm = null;
window.callback = function(obj) {
  vm.creatOrder(JSON.parse(obj));
};
export default {
  name: "",
  data() {
    return {
      title: "活动详情",
      state: 1,
      money: 1,
      isFree: false,
      people: 130,
      data: [],
      product_arr: [],
      productList: [],
      btn_status: true,
      loadingLock: true,
      status: "loading",
      orderId: 0,
      price: 0,
      token: "",
      activityNumber: "",
      version: "",
      source: "",
      isShow: false,
      mix_price: false,
      tips: "",
      order_btn: true,
      toast: "",
      select_price: 0
    };
  },
  components: {
    titleBar,
    lesson_loading
  },
  watch: {
    product_arr(curVal, oldVal) {
      console.log(curVal);
      let self = this;
      self.productList = [];
      for (let i = 0; i < curVal.length; i++) {
        let arr = {
          productID: curVal[i],
          num: 1
        };
        self.productList.push(arr);
      }
    },
    toast(newName, oldName) {
      let self = this;
      if (newName != "") {
        setTimeout(function() {
          self.toast = "";
        }, 2000);
      }
    }
  },
  methods: {
    showModal() {
      if (this.data.orderState != 0) return;
      this.isShow = true;
      this.$refs.modal.style.bottom = "-6.06rem";
      this.$refs.modal.style.transform = "translateY(-6.94rem)";
      this.$refs.modal.style.transition = "transform .5s ease-in-out";
    },
    close_tips() {
      this.tips = "";
    },
    closeModal() {
      this.btn_status = true;
      this.isShow = false;
      this.$refs.modal.style.transform = "translateY(6.06rem)";
      this.$refs.modal.style.transition = "transform .6s ease-in-out";
    },
    input_event(i) {
      let price = parseInt(this.data.classList[i].salePrice) == 0 ? 0 : 1;
      if (price != this.select_price) {
        let arr = [];
        arr.push(this.data.classList[i].productId);
        this.product_arr = arr;
        this.select_price = price;
      }
    },
    initData: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/parent/live/get-act-goods-list", {
          params: {
            token: self.token,
            activityNumber: self.activityNumber,
            version: self.version,
            source: self.source
          }
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        this.data = resp.data.data;
        this.data.orderState = 2;
        let price_arr = [];
        for (let i = 0; i < self.data.classList.length; i++) {
          let orderState = self.data.classList[i].orderState;
          let orderId = self.data.classList[i].orderId;
          let price = parseInt(self.data.classList[i].salePrice);
          let productId = self.data.classList[i].productId;
          if (orderState != 2) {
            self.data.orderState = 0;
            if (!self.product_arr.length) {
              self.select_price = price == 0 ? 0 : 1;
              self.product_arr.push(productId);
            }
          }
          if (orderId != 0 && !self.orderId) {
            self.orderId = orderId;
          }
          price_arr.push(price);
        }
        let max_price = Math.max.apply(null, price_arr);
        let min_price = Math.min.apply(null, price_arr);
        if (max_price == 0) {
          this.price = "免费";
        } else {
          this.price = min_price;
        }
        if (min_price == 0 && max_price > 0) {
          this.mix_price = true;
        }
        console.log(this.price);
        utils.sendLog(
          {
            token: self.token,
            version: "3.3.0",
            source: "h5",
            extensionJson: {
              type: parseInt(self.data.orderState + 1),
              activityID: self.activityNumber
            }
          },
          "jz0347"
        );
        if (self.data.classList.length) {
          this.loadingLock = false;
        } else {
          this.status = "empty";
        }
        this.$nextTick(function() {
          self.scroll = new BSroll(self.$refs.list_item, {
            click: true
          });
        });
      } else {
        this.loadingLock = true;
        this.status = "error";
      }
    },
    creatOrder: async function(obj) {
      console.log(obj);
      console.log(this.productList);
      let self = this;
      const [resp] = await ajax.all([
        ajax.post("/parent/live/order-add?token=" + self.token, {
          source: obj.source,
          version: obj.version,
          addressId: obj.deviceId,
          identity: "parent",
          userSource: "LIVENETSCHOOL",
          productList: self.productList,
          clientChannel: obj.channel,
          clientVersion: obj.appVersion,
          deviceBrand: obj.platform,
          deviceModel: obj.platform,
          OSName: obj.platform,
          OSVersion: obj.deviceVersion,
          form: "netschool_zhibo",
          activityNumber: self.activityNumber
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        self.load = false;
        self.order_btn = true;
        let result = resp.data.data;
        self.orderId = result.orderId;
        if (!this.select_price) {
          return this.$router.push({
            path:
              "/lesson/pay_sucess?token=" +
              self.token +
              "&sourceId=" +
              self.product_arr +
              "&version=" +
              self.version +
              "&source=" +
              self.source +
              "&hideTitleBar=1"
          });
        }
        let url =
          window.location.origin +
          "/#/lesson/pay_sucess?token=" +
          self.token +
          "&version=" +
          self.version +
          "&source=" +
          self.source +
          "&sourceId=" +
          self.product_arr +
          "&hideTitleBar=1";
        window.location =
          "hybird://method/payLiveCourse?orderId=" +
          self.orderId +
          "&successUrl=" +
          escape(url);
      } else {
        self.load = false;
        self.order_btn = true;
        self.toast = resp.data.msg;
      }
    },
    pay_click: function() {
      let self = this;
      if (!this.order_btn) return;
      utils.sendLog(
        {
          token: self.token,
          version: "3.3.0",
          source: "h5",
          extensionJson: {
            activityID: self.activityNumber
          }
        },
        "jz0349"
      );
      if (!self.productList.length) {
        return (this.toast = "请选择购买的课程");
      }
      this.order_btn = false;
      if (this.orderId) {
        let url =
          window.location.origin +
          "/#/lesson/pay_sucess?token=" +
          this.token +
          "&version=" +
          this.version +
          "&source=" +
          this.source +
          "&sourceId=" +
          this.product_arr +
          "&hideTitleBar=1";
        return (window.location =
          "hybird://method/payLiveCourse?orderId=" +
          this.orderId +
          "&successUrl=" +
          escape(url));
      }
      // let obj = '{"deviceVersion":"11.0.1","version":"332","channel":"AppStore","buildVersion":"3.3.3.1","deviceId":"563E7F43-6399-440C-99E6-F163A95DA408","source":"iOSRCParent","deviceType":"iOSx8664Simulator","packageName":"com.appKnowin.PRapidCalculation","platform":"iOS","appName":"RCParent","token":"MxTARa2dBPmM5QtYb1mdLkoZ_xmE6rNau_v653LR9hPc0k7zbqmdHiYesG9kI0SFK4DGaFPsMpiEUTnF3Ij0D4SO-Dx4JUwqF02DC86hg_o\/","mode":0,"appVersion":"3.3.2"}'
      // this.creatOrder(JSON.parse(obj))
      window.location = "hybird://method/nativeToJS?funcName=callback";
    },
    pay_event: function() {
      let self = this;
      utils.sendLog(
        {
          token: self.token,
          version: "3.3.0",
          source: "h5",
          extensionJson: {
            type: parseInt(self.data.orderState + 1),
            activityID: self.activityNumber
          }
        },
        "jz0348"
      );
      self.btn_status = false;
    },
    copy_event: function() {
      window.location = "hybird://method/copy2Clipboard?content=vip.knowbox.cn";
    },
    call_event() {
      window.location =
        "hybird://method/openBrowser?url=" + decodeURI("tel://400-010-0180");
    },
    show_method() {
      this.tips = "method";
    }
  },
  created: function() {
    let self = this;
    vm = this;
    self.token = utils.getQueryString("token");
    self.version = utils.getQueryString("version");
    self.activityNumber = utils.getQueryString("activityNumber");
    self.source = utils.getQueryString("source");
    self.initData();
  }
};
</script>

<style lang="scss">
.details_bottom {
  position: fixed;
  z-index: 100;
  bottom: 0;
  width: 100%;
  height: 1.1rem;
  background-color: #f5833d;
  z-index: 101;
  p {
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 0.38rem;
    line-height: 1.1rem;
    color: #ffffff;
  }
}
.details_bottom_left {
  float: left;
  height: 1.1rem;
  width: 55%;
  text-align: center;
  line-height: 0.88rem;
  background-color: #f8f2ea;
}
.details_money {
  box-sizing: border-box;
  padding-left: 0.5rem;
  line-height: 1.1rem;
  float: left;
}
.details_money_free {
  color: #ff714c;
  font-size: 0.36rem;
}
.details_money_nofree {
  color: #ff714c;
  font-size: 0.46rem;
  font-family: PingFangSC-Medium;
}
.details_money_nofree span {
  color: #ff714c;
  font-size: 0.24rem;
  font-weight: 100;
  font-family: PingFangSC-Medium;
}
.details_people {
  font-size: 0.24rem;
  padding-right: 0.7rem;
  line-height: 0.25rem;
  padding-top: 0.48rem;
  float: right;
  color: #9796a4;
  font-family: PingFangSC-Medium;
}
.details_bottom_right {
  text-align: center;
  width: 45%;
  float: right;
  line-height: 1.1rem;
  color: #ffffff;
  background-color: #f5833d;
  font-size: 0.36rem;
  font-family: PingFangSC-Medium;
}
.details_bottom_tips {
  position: fixed;
  bottom: 1.1rem;
  width: 100%;
  height: 0.6rem;
  font-family: PingFangSC-Medium;
  font-size: 0.26rem;
  line-height: 0.6rem;
  color: #ffffff;
  background-color: #000000;
  opacity: 0.7;
  text-align: center;
  z-index: 999;
}
.details_shadow {
  position: fixed;
  z-index: 99;
  opacity: 0.3;
  width: 100%;
  height: 100%;
  background-color: #000;
}
.details_bgimg {
  margin-top: 0.88rem;
  margin-bottom: 1.1rem;
  img {
    width: 100%;
  }
}
.details_modal {
  position: fixed;
  bottom: -6.06rem;
  // bottom: -6.06rem;
  z-index: 100;
  width: 100%;
  height: 6.06rem;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0.5rem 0.5rem 0;
  &_title {
    color: #56586a;
    &_top {
      font-family: PingFangSC-Medium;
      font-weight: 900;
      padding-bottom: 0.1rem;
      font-size: 0.38rem;
    }
    &_middle {
      margin-bottom: 0.18rem;
      font-family: PingFangSC-Regular;
      font-size: 0.26rem;
      span {
        padding-right: 0.3rem;
      }
    }
  }
  &_item {
    padding-bottom: 0.2rem;
    height: 4.5rem;
    overflow-y: scroll;
    &_main {
      position: relative;
      padding: 0.2rem 0;
      box-sizing: border-box;
      width: 100%;
      height: 1.25rem;
      font-size: 0.2rem;
      position: relative;
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background: #eeeeee;
        transform: scaleY(0.5);
      }
      &_header {
        float: left;
        margin: 0.1rem 0.2rem 0.1rem 0.1rem;
        width: 0.6rem;
        height: 0.6rem;
        background: pink;
        border-radius: 50%;
      }
      &_detail {
        position: relative;
        height: 100%;
        &_time {
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-bottom: 0.2rem;
          color: #9796a4;
        }
        &_other {
          font-family: PingFangSC-Regular;
          font-size: 0.24rem;
          color: #56546c;
          height: 0.2rem;
          line-height: 0.2rem;
          span {
            font-family: PingFangSC-Medium;
            margin-right: 0.2rem;
          }
          &_1 {
            font-size: 0.2rem;
            margin-right: 0.2rem;
            font-weight: normal;
            background-color: #eaebf1;
            padding: 0 0.1rem;
            border-radius: 0.2rem;
            color: #9ea2b7;
            -webkit-text-size-adjust: none;
          }
          &_2 {
            font-size: 0.2rem;
            margin-right: 0.2rem;
            font-weight: normal;
            background-color: #eaebf1;
            padding: 0 0.1rem;
            border-radius: 0.2rem;
            color: #b48051;
            -webkit-text-size-adjust: none;
          }
        }
      }
      &_radio {
        display: block;
        position: absolute;
        right: 0.57rem;
        bottom: 0.2rem;
        height: 0.36rem;
        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
        color: #ff714c;
        line-height: 0.36rem;
      }
      input[type="checkbox"] {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 100;
        opacity: 0;
        top: 0;
      }
      input:checked + label {
        // background-color: #fe6d32;
        border: 1px solid #9ea2b7;
      }
      input:checked + label::after {
        position: absolute;
        content: "";
        width: 0.16rem;
        height: 0.16rem;
        top: 0.08rem;
        left: 0.08rem;
        background-color: #9ea2b7;
        border-radius: 100%;
      }
      label {
        position: absolute;
        right: 0;
        bottom: 0.2rem;
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 50%;
        border: 1px solid #999;
      }
      input:checked + label::after {
        position: absolute;
        content: "";
        width: 0.16rem;
        height: 0.16rem;
        top: 0.08rem;
        left: 0.08rem;
        background-color: #9ea2b7;
        border-radius: 100%;
      }
      .no_check {
        opacity: 0.5;
      }
    }
  }
}
.mark {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.7);
  .tips_middle {
    position: absolute;
    padding: 0.5rem 0.4rem;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 5.8rem;
    height: 3.65rem;
    background-color: #fff;
    border-radius: 0.3rem;
    text-align: center;
    font-family: PingFangSC-Medium;
    h3 {
      font-size: 0.36rem;
      color: #56586a;
    }
    p {
      margin-top: 0.32rem;
      font-size: 0.26rem;
      line-height: 0.39rem;
      color: #8487a0;
    }
    .btn {
      margin-top: 0.2rem;
      overflow: hidden;
      span {
        display: inline-block;
        width: 2.35rem;
        height: 0.89rem;
        line-height: 0.89rem;
        font-size: 0.32rem;
        border-radius: 0.44rem;
        &:first-child {
          float: left;
          color: #e7be84;
          border: solid 1px #e7be84;
        }
        &:last-child {
          float: right;
          color: #fff;
          background-color: #e7be84;
          border: solid 1px #e7be84;
        }
      }
    }
  }
  .tips_bottom {
    position: absolute;
    padding: 0.6rem 0.5rem 0;
    bottom: 0;
    width: 100%;
    height: 5rem;
    background: #fff;
    border-radius: 0.34rem 0.34rem 0 0;
    font-family: PingFangSC-Medium;
    .announce_item {
      height: 2.1rem;
      overflow: hidden;
      h3 {
        font-size: 0.28rem;
        line-height: 0.42rem;
        color: #9796a4;
      }
    }
    p {
      margin-top: 0.1rem;
      height: 0.46rem;
      line-height: 0.46rem;
      font-size: 0.26rem;
      color: #9796a4;
      span {
        float: right;
        display: inline-block;
        width: 1.3rem;
        height: 0.46rem;
        background-color: #e7be85;
        border-radius: 0.23rem;
        font-size: 0.22rem;
        color: #fff;
        text-align: center;
        a {
          color: #fff;
        }
      }
      &:last-child {
        &:before {
          content: "";
          display: inline-block;
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 50%;
          background-color: #f5833d;
          margin: 0 0.1rem 0.06rem 0.03rem;
        }
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #f5833d;
      }
    }
  }
  h2 {
    margin-bottom: 0.4rem;
    font-size: 0.38rem;
    line-height: 0.46rem;
    color: #56586a;
  }
}
.toast {
  position: fixed;
  width: 3rem;
  height: 1.5rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  line-height: 1.5rem;
  text-align: center;
  color: #fff;
  z-index: 999;
}
</style>
